import { render, staticRenderFns } from "./epidemicRegister.vue?vue&type=template&id=19f91c26&scoped=true"
import script from "./epidemicRegister.vue?vue&type=script&lang=js"
export * from "./epidemicRegister.vue?vue&type=script&lang=js"
import style0 from "./epidemicRegister.vue?vue&type=style&index=0&id=19f91c26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f91c26",
  null
  
)

export default component.exports